export default "__VITE_ASSET__CSSxXjeI__"